export default __webpack_public_path__ + "static/media/1.970d1278.png";